import * as yup from 'yup'

export const schema = yup.object().shape({
   uf: yup.string().required(),
   periodoInicio: yup
      .mixed<string>()
      .concat(yup.date())
      .transform((curr, orig) => (orig === '' ? null : curr))
      .nullable(),
   periodoFim: yup
      .mixed<string>()
      .concat(yup.date())
      .transform((curr, orig) => (orig === '' ? null : curr))
      .nullable()
})
